import useResizeObserver from '@react-hook/resize-observer';
import { useLayoutEffect, useState } from 'react';

export type UseSizeReturn = DOMRectReadOnly | undefined;

const useSize = (target): UseSizeReturn => {
    const [size, setSize] = useState<DOMRectReadOnly>();

    useLayoutEffect(() => {
        setSize(target.current.getBoundingClientRect());
    }, [target]);

    useResizeObserver(target, (entry) => setSize(entry.contentRect));
    return size;
};

export default useSize;
